import { SideNavInterface } from '../../../interfaces/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '/dashboard/qualidade',
    title: 'Painel de qualidade',
    iconType: 'nzIcon',
    icon: 'dashboard',
    iconTheme: 'outline',
    submenu: [],
    userType: [1, 2, 3, 5],
  },
  {
    path: '',
    title: 'Gestão da captação',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'environment',
    submenu: [
      {
        path: '/dashboard/gestao-da-captacao/dashboard',
        title: 'Gestão de coletas',
        iconType: 'nzIcon',
        icon: 'project',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-captacao/add-local-coleta',
        title: 'Cadastrar local de coleta',
        iconType: 'nzIcon',
        icon: 'plus',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-captacao/rotas',
        title: 'Gestão de rotas',
        iconType: 'nzIcon',
        icon: 'edit',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-captacao/litros-coletados',
        title: 'Volume/Litragem',
        iconType: 'nzIcon',
        icon: 'safety-certificate',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
    ],
    userType: [2],
  },
  {
    path: '',
    title: 'Gestão da qualidade',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'bar-chart',
    submenu: [
      {
        path: '/dashboard/gestao-da-qualidade/analises-avulsas',
        title: 'Análises Avulsas',
        iconType: 'nzIcon',
        icon: 'search',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-qualidade/saude-higiene',
        title: 'Saúde e Higiene',
        iconType: 'nzIcon',
        icon: 'medicine-box',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-qualidade/saude',
        title: 'Saúde Mamária',
        iconType: 'nzIcon',
        icon: 'heart',
        iconTheme: 'outline',
        submenu: [],
        userType: [1],
      },
      {
        path: '/dashboard/gestao-da-qualidade/saude-nutricional',
        title: 'Saúde Nutricional',
        iconType: 'nzIcon',
        icon: 'heart',
        iconTheme: 'outline',
        submenu: [],
        userType: [1],
      },
      {
        path: '/dashboard/gestao-da-qualidade/higiene',
        title: 'Higiene e Segurança',
        iconType: 'nzIcon',
        icon: 'safety-certificate',
        iconTheme: 'outline',
        submenu: [],
        userType: [1],
      },
      {
        path: '/dashboard/gestao-da-qualidade/iqb',
        title: 'Qualidade Biológica',
        iconType: 'nzIcon',
        icon: 'stock',
        iconTheme: 'outline',
        submenu: [],
        userType: [1, 2],
      },
      {
        path: '/dashboard/gestao-da-qualidade/metabolismo-nutricao',
        title: 'Metabolismo e nutrição',
        iconType: 'nzIcon',
        icon: 'bar-chart',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-qualidade/desempenho-fisico-quimico',
        title: 'Desempenho Físico-Químico',
        iconType: 'nzIcon',
        icon: 'experiment',
        iconTheme: 'outline',
        submenu: [],
        userType: [1, 2],
      },
      {
        path: '/dashboard/gestao-da-qualidade/qualidade-industrial',
        title: 'Qualidade Industrial',
        iconType: 'nzIcon',
        icon: 'pie-chart',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-da-qualidade/analises-individuais',
        title: 'Individuais',
        iconType: 'nzIcon',
        icon: 'pie-chart',
        iconTheme: 'outline',
        submenu: [],
        userType: [1],
      },
    ],
    userType: [1, 2, 3],
  },
  {
    path: '/dashboard/importacao-amostras',
    title: 'Importação de amostras',
    iconType: 'nzIcon',
    icon: 'file-excel',
    iconTheme: 'outline',
    submenu: [],
    userType: [2],
  },
  {
    path: '',
    title: 'Gestão da bonificação',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'dollar',
    submenu: [
      {
        path: '/dashboard/modelo-bonificacao/bonificacao-laticinio',
        title: 'Gestão de bonificação',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'project',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/modelo-bonificacao',
        title: 'Configurar calculadora',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'calculator',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/modelo-bonificacao/alterar-modelo',
        title: 'Alterar modelo vigente',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'edit',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/modelo-bonificacao/bonificacao-retroativa-status',
        title: 'Solicitações retroativas',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-search',
        submenu: [],
        userType: [2],
      },
    ],
    userType: [2],
  },
  {
    path: '/dashboard/bonificacao',
    title: 'Pagamento por qualidade',
    iconType: 'nzIcon',
    icon: 'calculator',
    iconTheme: 'outline',
    submenu: [],
    userType: [1],
  },
  {
    path: '',
    title: 'Protocolos PQFL',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'safety-certificate',
    submenu: [
      {
        path: '/dashboard/pqfl/home',
        title: 'Visão geral',
        iconType: 'nzIcon',
        icon: 'project',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/pqfl/conservacao',
        title: 'Conservação',
        iconType: 'nzIcon',
        icon: 'global',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/pqfl/gestao-energetica',
        title: 'Gestão energética',
        iconType: 'nzIcon',
        icon: 'thunderbolt',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/pqfl/bem-estar-animal',
        title: 'Bem-estar animal',
        iconType: 'nzIcon',
        icon: 'heart',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/pqfl/responsabilidade-social',
        title: 'Responsabilidade social',
        iconType: 'nzIcon',
        icon: 'team',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
        nav: false,
      },
      {
        path: '/dashboard/pqfl/bpa/analises',
        title: 'BPA',
        iconType: 'nzIcon',
        icon: 'team',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
        nav: false,
      },
    ],
    userType: [2],
  },
  {
    path: '',
    title: 'Programa Mais Leite Saudável',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'appstore',
    submenu: [
      {
      path: '/dashboard/pmls/home',
      title: 'Visão geral',
      iconType: 'nzIcon',
      iconTheme: 'outline',
      icon: 'project',
      submenu: [],
      userType: [2],
    },
      {
      path: '/dashboard/pmls/lacpoints',
      title: 'Lacpoints',
      iconType: 'nzIcon',
      iconTheme: 'outline',
      icon: 'trophy',
      submenu: [],
      userType: [2],
    },
    ],
    userType: [2],
  },
  {
    path: '',
    title: 'Gestão de usuários',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'setting',
    submenu: [
      {
        path: '/dashboard/gestao-de-usuarios/gerenciamento-produtores',
        title: 'Produtores',
        iconType: 'nzIcon',
        icon: 'user',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-de-usuarios/gestao-grupos-produtores',
        title: 'Grupos de produtores',
        iconType: 'nzIcon',
        icon: 'team',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-de-usuarios/gerenciamento-tecnicos',
        title: 'Técnicos',
        iconType: 'nzIcon',
        icon: 'team',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
      {
        path: '/dashboard/gestao-de-usuarios/gerenciamento-transportadores',
        title: 'Transportadores',
        iconType: 'nzIcon',
        icon: 'car',
        iconTheme: 'outline',
        submenu: [],
        userType: [2],
      },
    ],
    userType: [2],
  },
];
